import ChartStatisticsStore from "./ChartStatistics/ChartStatisticsStore";
import HospitalDataStore from "./HospitalData/HospitalDataStore";
import PatientListStatisticsStore from "./PatientListStatistics/PatientListStatisticsStore";

export const DashBoardStore = {
    hospitalDataStore: new HospitalDataStore(),
    patientListStatisticsStore: new PatientListStatisticsStore(),
    chartStatisticsStore: new ChartStatisticsStore(),
};